import React from 'react';
import PropTypes from 'prop-types';
import ArrowRightIcon from '@domain-group/fe-co-icon/lib/js/chevron-right';
import * as styles from './allhomes-listing-suburb-info-link.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SuburbInfoLink = props => ___EmotionJSX("div", {
  css: styles.container
}, props.media.mobile && ___EmotionJSX("div", {
  css: styles.title
}, props.numberOfProperties, " propert", props.numberOfProperties > 1 ? 'ies' : 'y', " for sale in", ' ', props.suburbName), ___EmotionJSX("a", {
  css: styles.infoLink,
  href: props.linkUrl
}, ___EmotionJSX("span", {
  css: styles.text
}, "View ", props.suburbName, " suburb profile"), ___EmotionJSX(ArrowRightIcon, {
  size: "small"
})));
SuburbInfoLink.propTypes = {
  linkUrl: PropTypes.string,
  suburbName: PropTypes.string,
  numberOfProperties: PropTypes.number,
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    desktop: PropTypes.bool
  })
};
SuburbInfoLink.defaultProps = {
  linkUrl: '',
  suburbName: '',
  numberOfProperties: 0,
  media: {}
};
export default SuburbInfoLink;